<div class="company-info" [formGroup]="form">
  <div class="company-info-section-wrapper">
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "company.general.general_photo" | translate }}
        <span class="optional">
          {{ "general.optional" | translate }}
        </span>
      </div>
      <div class="company-info-section-media">
        <cowing-input-media *ngIf="(isEditingInfo && endGetInfo) || !isEditingInfo" [isForm]="true"
          [control]="form.get('file')" [name]="'file'" [acceptPhoto]="true" [inputStyle]="EInputMediaStyleType.rounded">
        </cowing-input-media>
      </div>
    </div>
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "company.general.general_data" | translate }}
        <span class="subtitle">{{
          "company.general.general_data_info" | translate
        }}</span>
      </div>
      <div class="company-info-section-name">
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.company-name' | translate" [control]="form.get('company_name')">
          </cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.business-name' | translate" [control]="form.get('business_name')">
          </cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.tax-id' | translate" [control]="form.get('tax_id')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input-location *ngIf="(isEditingInfo && endGetInfo) || !isEditingInfo"
            [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.address' | translate" [control]="form.get('fiscal_address')"
            (setLocation)="setLocation($event)">
          </cowing-input-location>
        </div>
        <div class="company-info-section">
          <cowing-input-dropdown [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [label]="'coworking.general.is-business-group' | translate" [control]="form.get('is_business_group')"
            [options]="[
              'coworking.general.yes' | translate,
              'coworking.general.no' | translate
            ]">
          </cowing-input-dropdown>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'coworking.general.group-name' | translate" [control]="form.get('business_group')">
          </cowing-input>
        </div>
      </div>
    </div>
    <div class="company-info-container">
      <div class="company-info-section-title">
        {{ "company.general.general_contact" | translate }}
        <span class="subtitle">{{
          "company.general.general_contact_info" | translate
        }}</span>
      </div>
      <div class="company-info-section-name">
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'company.general.name' | translate" [control]="form.get('name')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'company.general.phone' | translate" [control]="form.get('phone')"></cowing-input>
        </div>
        <div class="company-info-section">
          <cowing-input [inputStyle]="EInputStyleType.Secondary" [isForm]="true"
            [placeholder]="'company.general.email' | translate" [control]="form.get('email')"
            [readonly]="isCreateCompanyFromPanel"></cowing-input>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button [label]="'coworking.cancel' | translate" [type]="EButtonType.RoundedSecondary" [iconShow]="false"
      (event)="goBack()">
    </cowing-button>
    <cowing-button [disabled]="isDisabledForm" [label]="'company.general.save' | translate" [type]="EButtonType.Rounded"
      [iconShow]="false" (event)="editCompany()">
    </cowing-button>
  </div>
</div>
